import { ChevronDown } from "lucide-react";
import { Button } from "@/shared/ui/atelier";
import { cn } from "@/shared/utils/style.util";

type SidebarScrollCueProps = {
  show: boolean
  onClick: () => void
};

/**
 * Floating "Voir plus" affordance for the sidebar nav: a soft fade at the
 * bottom edge plus a brand-colored pill that scrolls the list to the bottom.
 * Both are hidden (and the pill removed from the tab order) once the user
 * reaches the bottom.
 */
function SidebarScrollCue({ show, onClick }: SidebarScrollCueProps) {
  return (
    <>
      <div
        aria-hidden="true"
        className={cn(
          "pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-sidebar from-40% to-transparent transition-opacity duration-150",
          "motion-reduce:transition-none",
          show ? "opacity-100" : "opacity-0",
        )}
      />
      <Button
        variant="primary"
        size="sm"
        rightIcon={<ChevronDown size={16} />}
        onClick={onClick}
        aria-label="Voir plus : afficher la suite du menu"
        aria-hidden={!show}
        tabIndex={show ? 0 : -1}
        className={cn(
          "absolute bottom-3 left-1/2 z-10 -translate-x-1/2 shadow-md transition-[opacity,transform] duration-150",
          "motion-reduce:translate-y-0 motion-reduce:transition-none",
          show
            ? "translate-y-0 opacity-100"
            : "pointer-events-none translate-y-1 opacity-0",
        )}
      >
        Voir plus
      </Button>
    </>
  );
}

SidebarScrollCue.displayName = "SidebarScrollCue";

export { SidebarScrollCue };
